import { render, staticRenderFns } from "./HealthStatusChip.vue?vue&type=template&id=631e0ef4&scoped=true"
import script from "./HealthStatusChip.vue?vue&type=script&lang=ts"
export * from "./HealthStatusChip.vue?vue&type=script&lang=ts"
import style0 from "./HealthStatusChip.vue?vue&type=style&index=0&id=631e0ef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631e0ef4",
  null
  
)

export default component.exports